import { Message } from 'element-ui'
// 时间格式化
export function formatDate(date, fmt) {
  date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

// 时间格式化2
export function timestampToTime(row, column) {
  if (row[column.property] === 0) {
    return ''
  }
  var date = new Date(row[column.property] * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = date.getDate() + ' '
  var h = date.getHours() + ':'
  var m = date.getMinutes()
  var s = date.getSeconds()
  return Y + M + D + h + m + s
}

// 数字格式化
export function numFormat(value) {
  if (!value) return '0.00'
  value = parseFloat(value).toFixed(2)
  var intPart = parseInt(Number(value)) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.00' // 预定义小数部分
  var value2Array = value.split('.')
  // =2表示数据有小数位
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分
    if (floatPart.length === 1) { // 补0,实际上用不着
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
}
// 数字格式化千位显示
export function numFormat_qian(value) {
  if (!value) return '0'
  value = parseFloat(value).toFixed(2)
  var intPart = parseInt(Number(value)) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
}
// 数字格式化 显示到小数点后三位
export function numFormat_san(value) {
  if (!value) return '0.000'
  value = parseFloat(value).toFixed(3)
  var intPart = parseInt(Number(value)) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.000' // 预定义小数部分
  var value2Array = value.split('.')
  // =2表示数据有小数位
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分
    if (floatPart.length === 1) { // 补0,实际上用不着
      return intPartFormat + '.' + floatPart + '00'
    } else if (floatPart.length === 2) {
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
}
// 获取日期 dates 代表获取 0今天，-1昨天，1明天的日期
export function getToday(dates) {
  let dd = new Date()
  let n = dates || 0
  dd.setDate(dd.getDate() + n)
  let y = dd.getFullYear()
  let m = dd.getMonth() + 1
  let d = dd.getDate()
  m = m < 10 ? '0' + m : m
  d = d < 10 ? '0' + d : d
  let day = y + '-' + m + '-' + d
  return day
}

// 获取日期 type:"s"开始,"e"结束，dates:不传或0代表本周，-1上周，1下周
export function getWeekday(type, dates) {
  let now = new Date()
  let nowTime = now.getTime()
  let day = now.getDay()
  if (day == 0) day = 7
  let longTime = 24 * 60 * 60 * 1000
  let n = longTime * 7 * (dates || 0)
  let dd = ''
  if (type == 's') {
    dd = nowTime - (day - 1) * longTime + n
  }
  if (type == 'e') {
    dd = nowTime + (7 - day) * longTime + n
  }
  dd = new Date(dd)
  let y = dd.getFullYear()
  let m = dd.getMonth() + 1
  let d = dd.getDate()
  m = m < 10 ? '0' + m : m
  d = d < 10 ? '0' + d : d
  let days = y + '-' + m + '-' + d
  return days
}

// 获取日期 type："s"开始,"e"结束，months:不传或0代表本月，-1上月，1下月
export function getMonthday(type, months) {
  let d = new Date()
  let year = d.getFullYear()
  let month = d.getMonth() + 1
  if (Math.abs(months) > 12) {
    months = months % 12
  }
  if (months != 0) {
    if (month + months > 12) {
      year++
      month = (month + months) % 12
    } else if (month + months < 1) {
      year--
      month = 12 + month + months
    } else {
      month = month + months
    }
  }
  month = month < 10 ? '0' + month : month
  let firstday = year + '-' + month + '-' + '01'
  let lastday = ''
  if (
    month == '01' ||
    month == '03' ||
    month == '05' ||
    month == '07' ||
    month == '08' ||
    month == '10' ||
    month == '12'
  ) {
    lastday = year + '-' + month + '-' + 31
  } else if (month == '02') {
    if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
      lastday = year + '-' + month + '-' + 29
    } else {
      lastday = year + '-' + month + '-' + 28
    }
  } else {
    lastday = year + '-' + month + '-' + 30
  }
  let day = ''
  if (type == 's') {
    day = firstday
  } else {
    day = lastday
  }
  return day
}

// 复制
export function copy(txt) {
  var oInput = document.createElement('input')
  oInput.value = txt
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand('Copy') // 执行浏览器复制命令
  oInput.remove()
  Message({
    message: '复制成功! [Copy Success!]',
    type: 'success'
  })
}

// 百分比
export function percentage(num, total) {
  if (num == 0 || total == 0) {
    return 0
  }
  return (Math.round(num / total * 10000) / 100.00)// 小数点后两位百分比
}
